module.exports = __webpack_public_path__ + "static/img/quarter.874b4bc3.png";